import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Internal_Audit from "./internal_Audit/Internal_Audit";
import MRM from "./mrm/MRM";
import Risk_Opportunities from "./risk_Opportunities/Risk_Opportunities";

const Management_requirement = () => {
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Management System Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="Internal_Audit"
        >
          <Nav variant="pills" className="">
            <Nav.Item>
              <Nav.Link eventKey="Internal_Audit">
                Internal Audit
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="MRM">MRM</Nav.Link>
            </Nav.Item>

             <Nav.Item>
              <Nav.Link eventKey="Risk_Opportunities">Risk Opportunities</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Internal_Audit">
              <Internal_Audit />
            </Tab.Pane>

            <Tab.Pane eventKey="MRM">
              <MRM />
            </Tab.Pane>

            <Tab.Pane eventKey="Risk_Opportunities">
              <Risk_Opportunities />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Management_requirement;
